export var DEFAULT_ROLE_TOKEN_HEADER = "x-role-token";
